import { Button, Image, VStack } from "native-base";
import React, { useState } from "react";

import IfeiraLogo from "@/assets/icons/secondary_icon.png";
import FormButton from "@/components/atoms/FormButton";
import SignupBySegmentModal from "@/components/organisms/SignupBySegmentModal";
import { useAppNavigation } from "@/hooks/application/navigation";
import { AuthNavigation } from "@/navigation/stacks/AuthenticationStack";

const WelcomeMobile = () => {
  const { navigate } = useAppNavigation<AuthNavigation>();

  const [modalVisible, setModalVisible] = useState(false);

  const goToLogin = () => {
    setModalVisible(false);
    navigate("login");
  };

  return (
    <>
      <VStack
        h="full"
        w="full"
        bg="secondary.400"
        p={10}
        justifyContent="space-between"
        alignItems="center">
        <Image source={IfeiraLogo} resizeMode="contain" w="1/2" h="100px" alt="ifeira logo" />
        <VStack w="full">
          <FormButton w="full" mb={22} onPress={() => setModalVisible(true)}>
            Sou Novo
          </FormButton>
          <FormButton
            w="full"
            mb={22}
            colorScheme="white"
            textColor="primary.700"
            onPress={() => goToLogin()}>
            Entrar
          </FormButton>
          <Button w="full" colorScheme="primary" variant="ghost" onPress={() => navigate("guest")}>
            Entrar como convidado
          </Button>
        </VStack>
      </VStack>
      <SignupBySegmentModal modalVisible={modalVisible} onClose={() => setModalVisible(false)} />
    </>
  );
};

export default WelcomeMobile;
